;(function() {
  'use strict'

  Controller.$inject = ["glUtils"];
  angular
    .module('glow.reporting')
    .component('surveyExplorerExcludedViewsDialog', {
      controller: Controller,
      templateUrl: 'survey-explorer-excluded-views-dialog.html',
      bindings: {
        excludedViews: '<',
        onRestore: '&',
        onClose: '&',
      },
    })

  /* @ngInject */
  function Controller(glUtils) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.all = all
    ctrl.none = none
    ctrl.toggle = toggle
    ctrl.isSelected = isSelected
    ctrl.restore = restore
    ctrl.close = close

    function onInit() {
      ctrl.selected = []
      ctrl.anchorIndex = null
    }

    function all() {
      ctrl.selected = ctrl.excludedViews.slice()
      ctrl.anchorIndex = null
    }

    function none() {
      ctrl.selected.length = 0
      ctrl.anchorIndex = null
    }

    function toggle(event, item, index) {
      glUtils.shiftSelect(
        event,
        index,
        ctrl.anchorIndex,
        ctrl.excludedViews,
        isSelected(item),
        setSelected
      )
      ctrl.anchorIndex = index
    }

    function setSelected(item, selected) {
      if (selected && !isSelected(item)) {
        ctrl.selected.push(item)
      }
      if (!selected && isSelected(item)) {
        var idx = ctrl.selected.indexOf(item)
        ctrl.selected.splice(idx, 1)
      }
    }

    function isSelected(item) {
      return ctrl.selected.indexOf(item) !== -1
    }

    function restore() {
      ctrl.onRestore({ $items: ctrl.selected })
    }

    function close() {
      ctrl.onClose()
    }
  }
})()
